import React from 'react';

/**
* Displays Item Status bar from item.status
*  - item.status.status_key: not-started, watched, completed, completed-noquiz
*  - item.status.status: Not Started, % Watched, Completed
*/

const DisplayStatus = (item) => {
    if (!item.status) {
        return false;
    }

    if (item.content_type === 'e-manual') {
        return false;
    }

    return true;
}

const ItemStatus = ({ item }) => {

    if (!DisplayStatus(item)) {
        return <></>;
    }


    const classes = `product_card__status status-${item.status.status_key}`

    return (
        <div className={classes}>
            <p>{item.status.status}</p>
        </div>
    );
};

export { ItemStatus, DisplayStatus };